import styled from '@emotion/styled';
import { type IconType } from '@innovamat/glimmer-icons';
import { useDigitalGuides } from '../../context';
import { VideoChapterContent } from '../../types/videoChapter';
import BlockContent from '../BlockContent';
import BlockWithIcon from '../BlockWithIcon';
import { InnerHtmlParser } from '../InnerHtmlParser';
import { Text } from '../Text';

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.dark['01']};
`;

type Props = {
  videoChapter: VideoChapterContent;
};

export default function MomentsBlockVideoChapter({ videoChapter }: Props) {
  const { t } = useDigitalGuides();

  const getIcon = (itemNumber?: string): IconType => {
    switch (itemNumber) {
      case '1':
        return 'SocialAfectiveIcon';
      case '2':
        return 'MathsIcon';
      case '3':
        return 'HistoricalIcon';
      default:
        return 'CulturalReferenceIcon';
    }
  };

  const getTitle = (itemNumber?: string) => {
    const baseKey = 'digitalguides.se.moment.video';
    switch (itemNumber) {
      case '1':
        return t(`${baseKey}.social`);
      case '2':
        return t(`${baseKey}.math`);
      case '3':
        return t(`${baseKey}.history`);
      default:
        return t(`${baseKey}.cultural`);
    }
  };

  const getItems = () => {
    const items = videoChapter?.items.filter((item) => 'content' in item.items);

    return items.map((item, index) => {
      if (!item?.items?.content) return null;

      const itemNumber = item.items.themes?.body;
      return (
        <BlockWithIcon icon={getIcon(itemNumber)} key={index}>
          <BlockContent title={t(getTitle(itemNumber))}>
            <StyledText>
              <InnerHtmlParser text={item.items.content} />
            </StyledText>
          </BlockContent>
        </BlockWithIcon>
      );
    });
  };

  return <>{getItems()}</>;
}
